import React from 'react';
import useRelativeTime from './getRelativeTime';

const RelativeTime = ({ dateString }) => {
  const relativeTime = useRelativeTime(dateString);

  return <span className="text-purple fw-500 font-14">{relativeTime}</span>;
};

export default RelativeTime;